(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["homepage-video"] && !window.DesignMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
    const video = document.querySelector(".video-homepage");
    const container = document.querySelector(".section-homepage-video");

    function adjustVideoSize() {
        const windowHeight = window.innerHeight;
        const windowWidth = window.innerWidth;
        const videoRatio = video.videoWidth / video.videoHeight;
        const containerRatio = windowWidth / windowHeight;

        if (video) {
            if (containerRatio > videoRatio) {
                // בדסקטופ: הווידאו ימלא את הרוחב ויחתך בגובה
                video.style.width = "100%";
                video.style.height = "auto";
                video.style.objectFit = "cover";
            } else {
                // במובייל: ימלא את הגובה, ישמור על יחס גובה-רוחב
                video.style.width = "auto";
                video.style.height = "100%";
                video.style.objectFit = "cover";
            }
        }
    }

    adjustVideoSize();
    window.addEventListener("resize", adjustVideoSize);
});

  } catch(e) { console.error(e); }
})();
})();
